/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CheckUserNameQueryVariables = {|
  username: string,
  mobileNumber: string,
|};
export type CheckUserNameQueryResponse = {|
  +checkUsername: ?$ReadOnlyArray<?{|
    +username: ?string
  |}>
|};
export type CheckUserNameQuery = {|
  variables: CheckUserNameQueryVariables,
  response: CheckUserNameQueryResponse,
|};
*/


/*
query CheckUserNameQuery(
  $username: String!
  $mobileNumber: String!
) {
  checkUsername(username: $username, mobileNumber: $mobileNumber) {
    username
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mobileNumber"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "username"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "mobileNumber",
        "variableName": "mobileNumber"
      },
      {
        "kind": "Variable",
        "name": "username",
        "variableName": "username"
      }
    ],
    "concreteType": "UsernameList",
    "kind": "LinkedField",
    "name": "checkUsername",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CheckUserNameQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CheckUserNameQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "b098b8e2b1817baa12e3574cfac49747",
    "id": null,
    "metadata": {},
    "name": "CheckUserNameQuery",
    "operationKind": "query",
    "text": "query CheckUserNameQuery(\n  $username: String!\n  $mobileNumber: String!\n) {\n  checkUsername(username: $username, mobileNumber: $mobileNumber) {\n    username\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '15dd52275ded8d71ff53e4e30c00dbef';

module.exports = node;
